import { maxNameLength } from "src/common/rxName";
import { zSidLabel } from "src/types";
import z from "zod";

export const zWorkflowAttr = z.object({
  specId: z.string(),
  attrId: z.string(),
});
export type ZWorkflowAttr = z.infer<typeof zWorkflowAttr>;

export const zWorkflowStep = z.object({
  id: z.string(),
  name: z.string().max(maxNameLength),
  displayName: z.string().max(maxNameLength).nullish(),
  description: z.string().nullish(),
  roles: zSidLabel.array().describe("Исполнители"),
  attributes: zWorkflowAttr
    .array()
    .nullish()
    .describe(
      "конфигурация атрибутов шага, используемая бэкендом для формирования схем",
    ),
  predecessors: zSidLabel.array().nullish().describe("Предшественники"),
  lastStep: z.boolean(),
});

export type ZWorkflowStep = z.infer<typeof zWorkflowStep>;
